import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

import { csv } from 'd3-fetch';

import { version } from '../package.json'

import {
  metricSettings
} from "@/assets/library/metrics.js";

import {
  parseModel
} from "@/assets/js/helpers.js";

import { scaleQuantile } from 'd3-scale';

export default new Vuex.Store({
  state: {
    modelData:[],
    modelID: "0_option.json",
    previousModelID: "",
    loadingFlag: true,
    metricHeaders: Object.keys(metricSettings),
    metricObject: {},
    previousMetricID: "",
    metricID: "",
    VERSION: version,
    pageIndex: 0,
    resetMetrics: false
  },
  getters:{
    getPageIndex: state =>{
      return state.pageIndex
    },
    getVersion: state =>{
      return state.VERSION
    },
    getModelData: state =>{
      return state.modelData;
    },
    getPreviousModelID: state =>{
      return state.previousModelID;
    },
    getModelID: state =>{
      return state.modelID;
    },
    getLoadingFlag: state =>{
      return state.loadingFlag;
    },
    getMetricObject: state =>{
      return state.metricObject;
    },
    getMetricHeaders: state =>{
      return state.metricHeaders
    },
    getMetricID: state =>{
      return state.metricID;
    },
    getPreviousMetricID: state =>{
      return state.previousMetricID;
    },
    getResetMetrics: state =>{
      return state.resetMetrics
    }
  },
  mutations: {
    setPageIndex(state, newPageIndex){
      state.pageIndex = newPageIndex;
    },
    setModelData( state, newModelData ){
      state.modelData = newModelData;
    },
    setModelID ( state, newModelID){
      state.previousModelID = state.modelID
      state.modelID = newModelID + "_option.json";
    },
    setLoadingFlag( state, newLoadingFlag ){
      state.loadingFlag = newLoadingFlag;
    },
    setMetricObject( state, newMetricObject){
      const c = Object.assign({}, state.metricObject);

      state.metricHeaders.forEach((key)=>{
        c[key].value = parseFloat(newMetricObject[key])
      });
      
      state.metricObject = c
    },
    setupMetricObject(state, newMetricObject){
      state.metricObject = newMetricObject
    },
    setMetricID ( state, newMetircID) {
        state.previousMetricID = state.previousMetricID === state.metricID ? "" : state.metricID;

        state.metricID = newMetircID
    },
    setPreviousMetricID( state, newPreviousMetricID){
      state.previousMetricID = newPreviousMetricID
      state.metricID = newPreviousMetricID
    },
    resetMetrics(state, toggle){
      state.resetMetrics = toggle;
    }
  },
  actions: {
    readModelData(context) {

      let modelData = [];
      const metricRating = [10,20,30,40,50,60,70,80,90,100];
      context.commit('setupMetricObject', metricSettings);

      csv('./data/data.csv', (d)=>{
        modelData.push(d)
      }).then(() =>{

        const defaultModel = modelData.filter((d)=>{
          return d.iteration === context.state.modelID.split("_option.json")[0]
        })[0];
      

        modelData.forEach((d) => {
          context.state.metricHeaders.forEach((objectKey) => {

            const value = parseFloat(d[objectKey]);

            if (!metricSettings[objectKey].data.includes(value)) {
              metricSettings[objectKey].data.push(value)
            }
          });
        });

        context.state.metricHeaders.forEach((objectKey)=>{

          const key = metricSettings[objectKey];

          const dataObject = key.data.sort((a, b) => { return a - b });

          key.scaleQuantile = scaleQuantile().domain(dataObject).range(metricRating);
        });

        context.commit('setMetricObject', defaultModel);
        context.commit('setModelData', modelData);
      });
    },
    async getModelByID ( context, dispatch ) {

      // const Bucket = "https://things-assets.qz.com/2020/leeside-exhibit/";
      const APIURL = "https://optimus.kpfui.dev/api/v2/";
      const [modelID, type] = dispatch;
      let model = null, treeData = null;

      const projectLocation = function (folder){
        return "20200823_Leeside/"+folder+"/";
      }

      // const bucketLocation = function(folder, modelID){
      //   return Bucket + folder + "/" + modelID
      // }

      try {
        
        // const test = await axios.get("https://things-assets.qz.com/2020/leeside-exhibit/models/0_option.json");

        // const modelLocation = bucketLocation('models', modelID)

        let response =  await axios.post(APIURL + 'getModelByID/', {
          'Bucket': 'kpf-poc-results-bucket-staging-us-east-1',
          'Key': projectLocation('models') + modelID
        });

        response.data = JSON.parse(response.data.model)
        
        // const response = await axios.get(modelLocation);
        // console.log("getModelByID -> response", response)

        if(type !== "context" && type !== 'metric'){
          const treeID = (modelID.split("_option.json")[0]) + '_trees.csv'
          // const treeIDOLD = `${projectLocation('trees')}` + (modelID.split("_option.json")[0]) + '_trees.csv'
          // const treeLocation = bucketLocation('trees', treeID);

          const trees = await axios.post(APIURL + 'getModelData/',{
            'Bucket': 'kpf-poc-results-bucket-staging-us-east-1',
            'Key' : projectLocation('trees') + treeID
          });

          // const trees = await axios.get(treeLocation)
          // console.log("getModelByID -> trees", trees)
          // let treeSplit = trees.data.split('\n');
          
          // if(treeSplit.length > 2){
          //   treeSplit.shift()
          //   treeData = treeSplit.map((d)=>{
          //     let s = d.split(",");
          //     return {
          //       x: s[0],
          //       y: s[1],
          //       z: s[2],
          //       type:s[3]
          //     }
          //   });
          // }

          if(trees.data.length > 2){
            treeData = trees.data;
          }
        }

        model = await parseModel(response.data, modelID);

      } catch (error) {
        if(error) console.warn(error);
      }
      return [model, treeData];
    }
  }
})